import React from "react";
import ProductSkeleton from "./ProductSkeleton";
import SubCategorySkeleton from "./SubCategorySkeleton";

const PosStateSkeleton = ({ currentState = "category" }) => {
  const renderSkeletonContent = () => {
    switch (currentState) {
      case "category":
        return <CategorySkeleton />;
      case "subcategory":
        return <SubCategorySkeleton />;
      case "products":
        return <ProductSkeleton />;
      default:
        return <CategorySkeleton />;
    }
  };

  return (
    <main className="pos-main">
      {/* Search Header Skeleton */}
      <div className="pos-header-container">
        <div className="pos-header">
          <div className="d-flex justify-content-between align-items-center w-100">
            <div className="skeleton-text skeleton-title"></div>
            <div className="d-flex align-items-center gap-3 flex-grow-1 justify-content-end">
              <div className="skeleton-search skeleton-search-input"></div>
              <div className="skeleton-icon skeleton-barcode-icon"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Dynamic Content based on state */}
      <div className="pos-container no-scrollbar">
        {renderSkeletonContent()}
      </div>

      <style jsx>{`
        .skeleton-text {
          background: linear-gradient(
            90deg,
            #f0f0f0 25%,
            #e0e0e0 50%,
            #f0f0f0 75%
          );
          background-size: 200% 100%;
          animation: loading 1.5s infinite;
          border-radius: 4px;
          height: 1rem;
        }

        .skeleton-title {
          width: 60px;
          height: 2rem;
        }

        .skeleton-search-input {
          width: 300px;
          height: 2.5rem;
          border-radius: 8px;
        }

        .skeleton-barcode-icon {
          width: 24px;
          height: 24px;
          border-radius: 4px;
        }

        .skeleton-icon {
          background: linear-gradient(
            90deg,
            #f0f0f0 25%,
            #e0e0e0 50%,
            #f0f0f0 75%
          );
          background-size: 200% 100%;
          animation: loading 1.5s infinite;
          border-radius: 4px;
        }

        @keyframes loading {
          0% {
            background-position: 200% 0;
          }
          100% {
            background-position: -200% 0;
          }
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
          .skeleton-search-input {
            width: 200px;
          }
        }

        @media (max-width: 576px) {
          .skeleton-search-input {
            width: 150px;
          }
        }
      `}</style>
    </main>
  );
};

// Category Skeleton Component
const CategorySkeleton = () => {
  return (
    <div className="category-section">
      <div className="skeleton-text skeleton-category-title mb-4"></div>
      <div className="category-grid">
        {Array.from({ length: 12 }).map((_, index) => (
          <div key={index} className="category-card skeleton-card">
            <div className="category-image">
              <div className="skeleton-image skeleton-category-image"></div>
            </div>
            <div className="skeleton-text skeleton-category-name"></div>
          </div>
        ))}
      </div>

      <style jsx>{`
        .skeleton-text {
          background: linear-gradient(
            90deg,
            #f0f0f0 25%,
            #e0e0e0 50%,
            #f0f0f0 75%
          );
          background-size: 200% 100%;
          animation: loading 1.5s infinite;
          border-radius: 4px;
          height: 1rem;
        }

        .skeleton-category-title {
          width: 120px;
          height: 2rem;
        }

        .skeleton-image {
          background: linear-gradient(
            90deg,
            #f0f0f0 25%,
            #e0e0e0 50%,
            #f0f0f0 75%
          );
          background-size: 200% 100%;
          animation: loading 1.5s infinite;
          border-radius: 8px;
        }

        .skeleton-category-image {
          width: 100%;
          height: 80px;
        }

        .skeleton-category-name {
          width: 80%;
          height: 1rem;
          margin: 0.5rem auto 0;
        }

        .skeleton-card {
          background: #fff;
          border: 1px solid #e9ecef;
          border-radius: 8px;
          padding: 1rem;
          text-align: center;
          transition: all 0.3s ease;
          cursor: pointer;
        }

        .skeleton-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .category-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
          gap: 1rem;
          padding: 1rem 0;
        }

        .category-card {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 0.5rem;
        }

        .category-image {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        @keyframes loading {
          0% {
            background-position: 200% 0;
          }
          100% {
            background-position: -200% 0;
          }
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
          .category-grid {
            grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
          }
        }

        @media (max-width: 576px) {
          .category-grid {
            grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
          }
        }
      `}</style>
    </div>
  );
};

export default PosStateSkeleton;
